import { render, staticRenderFns } from "./CreateWizard.vue?vue&type=template&id=59602023&scoped=true&"
import script from "./CreateWizard.vue?vue&type=script&lang=ts&"
export * from "./CreateWizard.vue?vue&type=script&lang=ts&"
import style0 from "./CreateWizard.vue?vue&type=style&index=0&id=59602023&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59602023",
  null
  
)

export default component.exports